<script setup lang="ts">
import { formatHour, formatPricePerKwh } from '../lib/format'
import type { HourPrice } from '@greenbow/composables'

defineProps<{
  today: readonly HourPrice[]
  tomorrow?: readonly HourPrice[] | null
}>()
</script>

<template>
  <div class="price-chart-a11y-table">
    <table>
      <caption>
        Spotpriser pr. time
      </caption>
      <thead>
        <tr>
          <th scope="col">Dag</th>
          <th scope="col">Tid</th>
          <th scope="col">Spotpris</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="p in today" :key="`today-${p.hour}`">
          <td>I dag</td>
          <td>{{ formatHour(p.hour) }}</td>
          <td>{{ formatPricePerKwh(p.price) }}</td>
        </tr>
        <tr v-for="p in tomorrow ?? []" :key="`tomorrow-${p.hour}`">
          <td>I morgen</td>
          <td>{{ formatHour(p.hour) }}</td>
          <td>{{ formatPricePerKwh(p.price) }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<style lang="scss" scoped>
// Visually hidden but accessible to screen readers.
// Wrapping in a <div> (instead of applying the class to <table> directly)
// avoids table-specific rendering that can bypass clip-path in some browsers.
.price-chart-a11y-table {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip-path: inset(50%);
  white-space: nowrap;
  border: 0;
}
</style>
